import axios, { AxiosRequestHeaders } from 'axios';
import { CONFIG } from 'config/environment_variables';
import { IRefreshTokenResponse, JWTPayload } from 'types';
import { LOCAL_STORAGE_KEYS } from 'constant';
import globalHeaders from 'utils/globalHeaders';
import Decode from 'utils/v1.1/decodeJWT';

const isTokenExpired = (tokenData: JWTPayload) => {
  const exp = tokenData?.exp;
  return typeof exp === 'number' && new Date(exp * 1000) < new Date();
};

export const API = axios.create({
  baseURL: `${CONFIG.API_URL}/api/v1`,
});

API.interceptors.request.use(
  async (config) => {
    const headers = await globalHeaders(true);

    config.headers = { ...headers } as AxiosRequestHeaders;
    return config;
  },
  (error) => Promise.reject(error),
);

API.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;
    if (err.response?.data?.error?.is_refresh_invalid) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.TOKEN);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.REFRESH);
      window.location.assign('/');
    } else if (
      err.response?.data?.error?.is_access_invalid === 'True' &&
      !originalConfig._retry
    ) {
      originalConfig._retry = true;
      try {
        if (isTokenExpired(Decode())) {
          const response: { data: IRefreshTokenResponse } = await API.post(
            '/v1.1/token/refresh/',
            {
              refresh: localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH),
              'tenant-id': localStorage.getItem(LOCAL_STORAGE_KEYS.TENANT),
            },
          );
          const { access } = response.data;
          localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, access);
          originalConfig.headers.Authorization = `Bearer ${access}`;
        }
        return API(originalConfig);
      } catch (_error) {
        return Promise.reject(_error);
      }
    }
    return Promise.reject(err);
  },
);
